import { REALITY_FIELD_NAMES } from "../../../smartsetter-utils/filters-dialog/data"
import { sanitizeFilter } from "../../../smartsetter-utils/filters-dialog/filterSchema"
import { isPotentialTierId } from "../components/potentialTierConstants"
import { normalizeLeadCallActivityFilters } from "./leadCallActivityFilters"

/**
 * Strip UI-only keys. Legacy saved filters may use likelihood_to_move + tier id; map to
 * potential_tier for the CRM agents API.
 */
export function serializeAgentListFilters(filters) {
  const mapped = filters.map((filter) => {
    const rest = sanitizeFilter(filter)
    if (rest.field === REALITY_FIELD_NAMES.BULK_LIST) {
      // `label` is for the filters dialog only.
      return { field: rest.field, type: rest.type || "is", value: rest.value }
    }
    if (
      rest.field === REALITY_FIELD_NAMES.LIKELIHOOD_TO_MOVE &&
      isPotentialTierId(rest.value)
    ) {
      return {
        field: REALITY_FIELD_NAMES.POTENTIAL_TIER,
        type: rest.type || "is",
        value: rest.value,
      }
    }
    return rest
  })
  return normalizeLeadCallActivityFilters(mapped)
}

/**
 * The `bulk_list` filter for a finished Bulk search. It is a normal filter, so the
 * filters dialog shows it, the saved views store it and a refresh keeps it. `label` is
 * only shown in the dialog.
 */
export function buildBulkListFilter({ list_id: listId, summary }) {
  return {
    field: REALITY_FIELD_NAMES.BULK_LIST,
    type: "is",
    value: listId,
    label: `Bulk search: ${summary.rows} rows, ${summary.agents} agents`,
  }
}
